import axios from "./index";

// クーポン関連のAPIクライアント。
// バックエンド: app/controllers/api/v1/coupons_controller.rb。

const BASE = "/api/v1/coupons";

export default {
  // 全クーポンの名称一覧を取得する（フェイスシートTOPのクーポン名検索セレクトボックス用）。
  fetchCouponNames(): Promise<string[]> {
    return axios.get(`${BASE}`).then((response) => response.data.items ?? []);
  }
};
